export const iconFontAwesomeMedicalHealthBiohazard = (
	<i className="fa-solid fa-biohazard"></i>
);
